export const environment = {
  production: true,
  apiUrl: 'https://api-callsheets-dev.creativeops.pwc.com', //"http://localhost:8080",
  discoveryUrl:
    'https://login.microsoftonline.com/831f8b7b-7bbc-4d34-a62b-7baf9792d24a/v2.0', //"http://localhost:9444/realms/openam",
  clientId: '29e7c5bc-2bf1-4cbf-b148-626e326156f0', //"webapp-openam",
  scope: 'openid profile email',
  workfrontUrl: 'https://pwcmktg.sb01.workfront.com',
  assetsUrl: 'https://nus2slwbshed001.z13.web.core.windows.net/headshots/',
  envoyInviteUrl: 'https://dashboard.envoy.com/visitors/invites/',
  supportUrl: 'https://forms.office.com/r/zxPSiPprB9',
  revokeTokenEndpoint:
    'https://login.microsoftonline.com/831f8b7b-7bbc-4d34-a62b-7baf9792d24a/oauth2/v2.0/logout',
};
